
import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const PurchaseQuoteFileList = ({
  apiRef,
  columns,
  files,
  error,
  loading,
  handleRowEditStart,
  handleRowEditStop,
  handleCellFocusOut,
  columnVisibilityModel
}) => {
  return (
    <div style={{ display: 'flex', height: '350px' ,  minWidth: '100%'}}>
      <div style={{ flexGrow: 1 ,  minWidth: '100%' }}>
        <DataGrid
          apiRef={apiRef}
          rows={files ? files : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '프로젝트_첨부파일_리스트' },
          }}
          loading={loading}
          editMode="row"
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          onCellFocusOut={handleCellFocusOut}
          initialState={{ pinnedColumns: { right: ['actions'] } }}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default PurchaseQuoteFileList;


